import { ComponentProps, forwardRef } from "react";

import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const checkbox = cva(
  "text-brand-500 h-4 w-4 shrink-0 cursor-pointer rounded-sm border-slate-300 hover:border-slate-400 focus:ring-transparent",
  {
    variants: {
      disabled: {
        true: "cursor-not-allowed opacity-50 hover:border-slate-300",
      },
    },
  },
);

type NativeInputProps = ComponentProps<"input">;

type CheckboxVariantProps = VariantProps<typeof checkbox>;

export type Props = CheckboxVariantProps & {
  id?: string;
  checked?: boolean;
  className?: string;
} & NativeInputProps;

const Checkbox = forwardRef<HTMLInputElement, Props>(
  (
    { id, checked, defaultChecked, onChange = () => {}, className, ...rest },
    ref,
  ) => {
    return (
      <input
        id={id}
        type="checkbox"
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={onChange}
        className={twMerge(checkbox({ className, disabled: rest.disabled }))}
        ref={ref}
        {...rest}
      />
    );
  },
);

Checkbox.displayName = "Checkbox";

export default Checkbox;
